import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BookCard from '../components/BookCard';
import BookForm from '../components/BookForm';
import FilterBtns from '../components/FilterBtns';
import fetchBooks from '../redux/books/thunk/fetchBooks';

const HomePage = () => {
  const dispatch = useDispatch();
  const { items, searchValue, categoryValue } = useSelector(
    (state) => state.books
  );

  useEffect(() => {
    dispatch(fetchBooks());
  }, [dispatch]);

  const filterBySearchValue = (book) => {
    return book.name.toLowerCase().includes(searchValue.trim().toLowerCase());
  };

  const filterByCategoryValue = (book) => {
    if (categoryValue === 'featured') {
      return book.featured;
    }
    return true;
  };

  return (
    <main className="py-12 2xl:px-6">
      <div className="container grid xl:grid-cols-[auto_350px] 2xl:grid-cols-[auto_400px] gap-4 2xl:gap-8">
        <div className="order-2 xl:-order-1">
          <div className="flex items-center justify-between mb-12">
            <h4 className="mt-2 text-xl font-bold">Book List</h4>

            <FilterBtns />
          </div>
          <div className="lws-bookContainer">
            {items
              .filter(filterBySearchValue)
              .filter(filterByCategoryValue)
              .map((book) => (
                <BookCard book={book} key={book.id} />
              ))}
          </div>
        </div>
        <BookForm />
      </div>
    </main>
  );
};

export default HomePage;
